import { AccountBalanceWalletOutlined } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { WidgetComponentMaps } from "../../../common/WidgetComponentMaps";
import { filledButton } from "../../../ui/styles/buttonStyles";
import { PayoutMethodsList } from "./PayoutMethodsList";

export const PayoutMethodsWidget = ({ swapyName = "payoutMethodsWidget", sx }) => {
  return (
    <WidgetComponentMaps
      swapyName={swapyName}
      title="Payout Methods"
      description="Manage the payment and payout methods connected to this business."
      icon={<AccountBalanceWalletOutlined />}
      sxProp={{
        ...sx,
        minHeight: { xs: 220, md: 240 },
      }}
    >
      <Box sx={{ flex: 1 }} />

      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <BaseModalComponent
          modalKey="Organization-PayoutMethods-Business"
          modalLabel="Payout Methods"
          elementTrigger={<Button sx={filledButton}>Manage payout methods</Button>}
        >
          <PayoutMethodsList />
        </BaseModalComponent>
      </Box>
    </WidgetComponentMaps>
  );
};
